import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {
  catchError,
  finalize,
  from,
  map,
  Observable,
  switchMap,
  throwError,
} from 'rxjs';
import { NetworkWarningDialogService } from 'src/app/services/network-warning-dialog.service';

@Injectable()
export class LogginInterceptor implements HttpInterceptor {
  token: string | null | undefined;
  constructor(
    private router: Router,
    private networkWarningService: NetworkWarningDialogService,
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      map((event) => {
        return event;
      }),
      catchError((err) => {
        if (err.status === 401) {
          this.router.navigate(['/unauthorized']);
        }
        if (err.status === 504 && request.method === 'POST') {
          return from(this.checkPreflight(request.url)).pipe(
            switchMap((status) => {
              if (status === 418) {
                this.networkWarningService.openNetworkWarningDialog();
              }
              return throwError(() => error);
            }),
          );
        }
        if (err.status === 418) {
          this.networkWarningService.openNetworkWarningDialog();
        }
        const error = err.error.message || err.statusText;
        return throwError(err);
      }),
      finalize(() => {}),
    );
  }

  private async checkPreflight(url: string): Promise<number | null> {
    try {
      const res = await fetch(url, {
        method: 'OPTIONS',
      });
      return res.status;
    } catch (err) {
      return null;
    }
  }
}
